import {
  Button,
  Paper,
  Grid,
  TextField,
  Select,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Typography,
  Tab,
  Tabs,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import * as React from "react";
import { observable, action, computed, toJS, autorun } from "mobx";
import { createStyles, withStyles } from "@material-ui/core/styles";
import { config } from "../../../../../../src/config";

// import { authStore } from "src/modules/auth";
import { companiesAdminStore } from "..";
import { observer } from "mobx-react";
import { Loading } from "../../../../../../src/components/loading";
import { history } from "../../../../../../src/history.js";
import { withRouter } from "react-router";
import { AdminToolBar } from "../../../../../../src/modules/admin/components";
import { Route, RouteComponentProps, Switch, RouteProps } from "react-router";
import CompaniesForm from "./CompaniesForm";
import CompanyRelations from "./CompanyRelations";
import { validationsStore } from "../../../../validations";
import { permissionsStore } from "../../Permissions";
import CompaniesSettings from "./CompaniesSettings"; // E-105

const styles = createStyles({
  root: {
    width: "100%",
    // height: "100%",
    margin: "0 auto",
    // padding: "1.5rem",
    // display: "flex",
    flexDirection: "column",
  },
  rowContainer: {
    width: "100%",
    display: "flex",
    alignContent: "center",
    margin: "0 auto",
    // padding: "3rem",
  },
  columnContainer: {
    width: "100%",
    display: "flex",
    margin: "0 auto",
    // padding: "3rem",
  },
  textField: {
    display: "flex",
    paddingRight: "24px",
  },
  roleSelect: {
    minWidth: "9rem",
  },
  companySelect: {
    minWidth: "16.5rem",
  },
  appRoleSelect: {
    minWidth: "16.5rem",
    paddingTop: "1.5rem",
  },
  formContainer: {
    width: "100%",
    padding: "1.5rem",
  },
  submitContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row-reverse",
  },
  submitButton: {
    // backgroundColor: "#2A2A55",
    // border: "1px solid #2D4D73",
    // color: "#FAFAFA",
  },
  flexContainer: {
    height: "100%",
  },
});

@observer
class CompaniesAdminDetails extends React.Component<any> {
  public state = { current_tab: 0, deleteDialogOpen: false };

  @observable
  public loaded_company: any;

  @observable
  public loaded: boolean = false;

  @observable
  protected validations = {
    CompanyName: {
      validateFunctions: [
        {
          functionName: "regexTest",
          regexParam: /^\s*(?:[\w\.]\s*){2,50}$/,
          errorMessage: "Company Name must be more than 2 characters",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: [""],
    },
    // C-094.03
    CompanyPhone: {
      validateFunctions: [
        {
          functionName: "regexPhone",
          regexParam: /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/,
          errorMessage: "Must be a valid Phone Number*",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: ["Must be a valid Phone Number"],
    },
    CompanyEmail: {
      validateFunctions: [
        {
          functionName: "regexTest",
          regexParam:
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          errorMessage: "Must enter a valid Email",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: [
        "First name must be more than 2 characters",
        "Email must be unique",
      ],
    },
    // E-053.1 // E-105
    // CompanyApprovalOrderEmail: {
    //   validateFunctions: [
    //     {
    //       functionName: "regexTest",
    //       regexParam: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    //       errorMessage: "Must enter a valid Email",
    //       active: true,
    //     },
    //   ],
    //   valid: this.props.match.params.view_type !== "create",
    //   errorMessage: [
    //     "First name must be more than 2 characters",
    //     "Email must be unique",
    //   ],
    // },
  // E-105 new
    CompanyMinTransactionFee: {
      validateFunctions: [
        {
          functionName: "regexTest",
          regexParam: /^(0\.(0[1-9]|[1-9]\d?)|[1-9]\d*(\.\d{1,2})?)$/,
          errorMessage: "Must be a valid transaction fee of $0.01 or greater",
          active: true,
        },
      ],
      valid: this.props.match.params.view_type !== "create",
      errorMessage: ["Must be a valid Transaction Fee"],
    },

  // E-105 new
  // claimApprovalDetermination: {
  //   validateFunctions: [
  //     {
  //       functionName: "regexTest",
  //       regexParam: /^(grossProfit|netProfit)$/,
  //       errorMessage: "Must be either 'grossProfit' or 'netProfit'",
  //       active: true,
  //     },
  //   ],
  //   valid: this.props.match.params.view_type !== "create",
  //   errorMessage: ["Must be either 'grossProfit' or 'netProfit'"],
  // },
};

  constructor(props: any) {
    super(props);
    validationsStore.resetValidator();
  }

  public getSubmitTooltipInfo = () => {
    const content = Object.keys(validationsStore.validator).map(
      (key, index) => {
        if (!validationsStore.validator[key].valid) {
          return (
            <div key={index}>
              {
                validationsStore.validator[key].validateFunctions[0]
                  .errorMessage
              }
            </div>
          );
        } else {
          return null;
        }
      }
    );
    return content;
  };

  @action
  public loadCompany = async () => {
    await companiesAdminStore.getSitesList();
    await companiesAdminStore.getDistributorList(); //D-011
    if (this.props.match.params.view_type === "create" && !this.loaded) {
      companiesAdminStore.setBlankCompany();
      this.loaded_company = companiesAdminStore.currentCompany;
    } else {
      await companiesAdminStore.getCompanyByID(this.props.match.params.id);
      this.loaded_company = {
        ...companiesAdminStore.currentCompany,
      };
    }
  };

  public componentDidMount = async () => {
    await this.loadCompany();
    if (Object.entries(validationsStore.validator).length === 0) {
      validationsStore.startValidator(this.validations);
    }
  };

  public handleChangeTab = (event: any, value: number) => {
    this.setState({
      ...this.state,
      current_tab: value,
    });
  };

  public getPageContent = (current_tab: number) => {
    switch (current_tab) {
      case 0: {
        return (
          <CompaniesForm
            currentCompany={this.loaded_company}
            view_type={this.props.match.params.view_type}
          />
        );
      }
      case 1: {
        return (
          <CompaniesSettings
            currentCompany={this.loaded_company}
            view_type={this.props.match.params.view_type}
          />
        );
      }  // E-105
      case 2: {
        return (
          <CompanyRelations
            currentCompany={this.loaded_company}
            view_type={this.props.match.params.view_type}
          />
        );
      }
      default: {
        return <div>no tab found</div>;
      }
    }
  };

  public getDeleteDialog = (active: boolean, user: any) => {
    return (
      <Dialog
        open={active}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onBackdropClick={() => this.setState({ deleteDialogOpen: false })}
      >
        <DialogTitle>
          {!this.loaded_company?.PortalDeletedAt
            ? "Confirm Disable"
            : "Confirm Enable"}{" "}
          {this.state.deleteDialogOpen ? user.CompanyName : ""}?
        </DialogTitle>
        <DialogActions>
          {!this.loaded_company?.PortalDeletedAt ? (
            <Button
              variant="contained"
              classes={{ root: this.props.classes.submitButton }}
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.disable()}
              color="primary"
            >
              Disable
            </Button>
          ) : (
            <Button
              variant="contained"
              classes={{ root: this.props.classes.submitButton }}
              // tslint:disable-next-line: jsx-no-lambda
              onClick={() => this.enable()}
              color="primary"
            >
              Enable
            </Button>
          )}

          <Button
            variant="contained"
            classes={{ root: this.props.classes.submitButton }}
            // tslint:disable-next-line: jsx-no-lambda
            onClick={() => this.setState({ deleteDialogOpen: false })}
            color="primary"
            autoFocus={true}
          >
            Go Back
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  public render() {
    let approvalEmailDta = this.loaded_company?.CompanyApprovalOrderEmail;  //E-053.1
    const { classes, routeProps } = this.props;
    const deleteDialog = this.getDeleteDialog(
      this.state.deleteDialogOpen,
      this.loaded_company
    );
    if (
      !this.loaded_company ||
      !companiesAdminStore.loaded ||
      !validationsStore.loaded
    ) {
      return <Loading />;
    }

    const getTabs = () => {
      return (
        <Tabs
          value={this.state.current_tab}
          // tslint:disable-next-line: jsx-no-lambda
          onChange={this.handleChangeTab}
          indicatorColor="secondary"
          textColor="secondary"
          classes={{
            root: classes.tabsRoot,
            flexContainer: classes.flexContainer,
          }}
          style={{ height: "100%" }}
        >
          <Tab
            classes={{
              root: classes.tabRoot,
            }}
            label="Detail"
          />
          <Tab  // E-105
            classes={{
              root: classes.tabRoot,
            }}
            label="Settings"
          />
          <Tab
            classes={{
              root: classes.tabRoot,
            }}
            label="Relation"
          />
        </Tabs>
      );
    };

    const page_content = this.getPageContent(this.state.current_tab);
    return (
      <div className={classes.root}>
        {deleteDialog}
        <AdminToolBar
          pageTitle={"Company Edit " + this.loaded_company.CompanyName}
          tabs={getTabs()}
        />
        {page_content}
        <Grid item={true} xs={6}>
          <div
            className={classes.submitContainer}
            style={{
              display:
                this.props.match.params.view_type === "detail" ? "none" : "",
            }}
          >
            <Tooltip
              title={this.getSubmitTooltipInfo()}
              disableHoverListener={!this.submitDisabled()}  //E-053.1
            >
              <div>
                  <Button
                    classes={{ root: classes.submitButton }}
                    onClick={this.submit}
                    disabled={this.submitDisabled() || this.loaded_company.PortalDeletedAt} //B-014
                    variant="contained"
                  >
                    Submit
                  </Button>
              </div>
            </Tooltip>
            {permissionsStore.checkPermissionByCategoryAndType(
              "user",
              "delete"
            ) ? (
              !this.loaded_company?.PortalDeletedAt ? (
                <Button
                  classes={{ root: classes.submitButton }}
                    disabled={this.props.match.params.view_type !== "edit"}
                  // tslint:disable-next-line: jsx-no-lambda
                  onClick={() => this.setState({ deleteDialogOpen: true })}
                  variant="contained"
                >
                  Disable
                </Button>
              ) : (
                <Button
                  classes={{ root: classes.submitButton }}
                    disabled={this.props.match.params.view_type !== "edit"}
                  // tslint:disable-next-line: jsx-no-lambda
                  onClick={() => this.setState({ deleteDialogOpen: true })}
                  variant="contained"
                >
                  Enable
                </Button>
              )
            ) : (
              ""
            )}
          </div>
        </Grid>
      </div>
    );
  }


    @action
    protected disable = async () => {
      await companiesAdminStore.disableCompany(this.props.match.params.id);
      return this.props.history.push("/admin/companies");
    };

    @action
    protected enable = async () => {
      await companiesAdminStore.enableCompany(this.props.match.params.id);
      return this.props.history.push("/admin/companies");
    };

    //E-053.1
    @action
    protected submitDisabled = () => {
      for (const key in validationsStore.validator) {
          if (validationsStore.validator.hasOwnProperty(key)) {
            if (!validationsStore.validator[key].valid) return true;
        }
      }
      if (this.loaded_company.PortalDeletedAt) return true;
      return false;
    };

  @action
  protected submit = async () => {
    await companiesAdminStore.saveCompany(this.loaded_company);
    return this.props.history.push("/admin/companies");
  };
}

export default withStyles(styles, { withTheme: true })(
  withRouter(CompaniesAdminDetails)
);



// WEBPACK FOOTER //
// ./src/modules/admin/modules/CompaniesAdmin/components/CompaniesAdminDetails.tsx